import React from 'react';
import './ui.css';

const Spinner: React.FC<{ className?: string }> = ({ className = '' }) => (
  <span className={`ui-spinner ${className}`} aria-hidden="true" />
);

export default Spinner;
